export default __webpack_public_path__ + "static/1053-049de2c8b7035e1e1320edb028300def.gif";